export const EVENT_COLUMN = 'event';
export const METRIC_COLUMN = 'metric';
export const RESTRICTION_BANNER_ID = 'restriction-banner';
export const EVENTS_CARD_ID = 'events-column';
export const AVAILABLE_CARD_ID = 'available-columns';
export const METRICS_CARD_ID = 'metrics-column';
export const SELECTED_CARD_ID = 'selected-column';
export const BTN_CANCEL_ID = 'btn-cancel';
export const BTN_APPLY_ID = 'btn-apply';
export const EVENT_CARD_TITLE = 'Event';
export const AVAILABLE_CARD_TITLE = 'Available';
export const METRIC_CARD_TITLE = 'Metric';
export const SELECTED_CARD_TITLE = 'Selected';
//# sourceMappingURL=index.js.map